import { render, staticRenderFns } from "./InfoPrint.vue?vue&type=template&id=457c5a99&scoped=true&lang=pug&"
import script from "./InfoPrint.vue?vue&type=script&lang=js&"
export * from "./InfoPrint.vue?vue&type=script&lang=js&"
import style0 from "./InfoPrint.vue?vue&type=style&index=0&id=457c5a99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c5a99",
  null
  
)

export default component.exports